import React from 'react';
import QueryPageTemplate from 'src/pages/QueryPages/components/QueryPageTemplate';
import { PATHS } from 'src/constants/config';

const Repurpose = () => {
  return (
    <QueryPageTemplate
      queryStatuses={['repurposed', 'insightsNotIncluded', 'clientPassed', 'journalistPassed']}
      title="Repurpose"
      path={PATHS.QUERY_PROFILE.value}
      pageType="repurpose"
    />
  );
};

export default Repurpose;
